import { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { useHistory } from "react-router-dom";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
    HeaderSection,
    LogoContainer,
    Burger,
    NotHidden,
    Menu,
    CustomNavLinkSmall,
    Label,
    Outline,
    Span,
    NavCTA,
} from "./styles";
import { SvgIcon } from "../../common/SvgIcon";

const Header = ({ t }: { t: TFunction }) => {
    const [visible, setVisibility] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const toggleButton = () => {
        setVisibility(!visible);
    };

    const navigateTo = (path: string) => {
        history.push(path);
        setVisibility(false);
    };

    const MenuItem = () => {
        return (
            <>
                <CustomNavLinkSmall onClick={() => navigateTo("/")}>
                    <Span>{t("Home")}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => navigateTo("/services")}>
                    <Span>{t("Services")}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => navigateTo("/solutions")}>
                    <Span>Solutions</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => navigateTo("/contact")}>
                    <Span>{t("Contact")}</Span>
                </CustomNavLinkSmall>
                <NavCTA>
                    <CustomNavLinkSmall onClick={() => navigateTo("/book")}>
                        <Span>
                            <Button>Book a Call</Button>
                        </Span>
                    </CustomNavLinkSmall>
                </NavCTA>
            </>
        );
    };

    return (
        <HeaderSection $scrolled={scrolled}>
            <Container>
                <Row justify="space-between">
                    <LogoContainer to="/" aria-label="homepage">
                        <SvgIcon src="logo-dtt.png" width="auto" height="60px" />
                    </LogoContainer>
                    <NotHidden>
                        <MenuItem />
                    </NotHidden>
                    <Burger onClick={toggleButton}>
                        <Outline />
                    </Burger>
                </Row>
                <Drawer closable={false} open={visible} onClose={toggleButton}>
                    <Col style={{ marginBottom: "2.5rem" }}>
                        <Label onClick={toggleButton}>
                            <Col span={12}>
                                <Menu>Menu</Menu>
                            </Col>
                            <Col span={12}>
                                <Outline />
                            </Col>
                        </Label>
                    </Col>
                    <MenuItem />
                </Drawer>
            </Container>
        </HeaderSection>
    );
};

export default withTranslation()(Header);
